import React from "react";
import { Loan } from "../../components/Loan";
import { Filter } from "../../components/Filter";
import { Loading } from "../../components/Loader";
import AppClass from "../../AppClass";
import moment from "moment";
import * as XLSX from "xlsx";
import toastMessage from "../../components/toastMessage";
import { Pagination } from "../../components/Pagination";
import CardCount from "../../components/CardCount/CardCount";
import { formatMoney } from "../../configs/formatCurrency";
import { connect } from "react-redux";

let copyData = [];

class LoanList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      response: {},
      apps: [],
      loans: [],
      isLoading: false,
      message: "Please wait...",
      start_date: moment().subtract("30", "days").format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      pageOfItems: [],
      is_retrieve_setting: false,
      loan_ids: [],
      setting_id: "",
      template_modal: false,
      long_term_purpose: [],
      short_term_purpose: [],
      loan_products: [],
      loan_type: "",
      loan_product: "",
      loan_types: [],
      app_ids: [],
      totalItemsCount: 0,
      page: 1,
      limit: 10,
      summary: {},
      status: null,
    };
  }

  componentDidMount = async () => {
    this.handleInitial();
  };

  componentDidUpdate(prevProps) {
    if (this.props.filters !== prevProps.filters) {
      this.handleInitial();
    }
  }

  handleInitial = async () => {
    const { apps } = this.props;

    let f_apps = [];

    for (let el of apps) {
      f_apps.push({
        label: el.name,
        value: el._id,
      });
    }

    await this.setState({ apps: f_apps });

    await this.get_loan_by_apps(true, f_apps);

    if (apps.length === 1) {
      this.onChangeSacco({ label: apps[0].name, value: apps[0]._id });
    }

    this.getFiltersFromLCStorage();
  };

  getFiltersFromLCStorage = () => {
    const { filters } = this.props;

    this.setState({ ...filters });

    Object.keys(filters).forEach((key) => {
      if (filters[key] && filters[key] !== "") {
        this.setState({
          [key]: filters[key],
        });
      }
    });
  };

  get_loan_by_apps(isLoading, apps) {
    let app_ids = AppClass.get_app_ids(apps);

    this.get_loans(isLoading, app_ids);

    this.setState({ app_ids });
  }

  onChangeSacco(e) {
    this.setState({ appid: e, loan_id: undefined }, () => {
      this.get_interest_rate(true, e.value);
      this.get_loans(true);
      this.get_members(e.value);
    });
  }

  onChangeLoanType(e) {
    let value = e.target.value,
      loan_products = [],
      { long_term_purpose, short_term_purpose } = this.state;

    if (long_term_purpose && value === "Long-term Loans") {
      for (let product of long_term_purpose) {
        loan_products.push(product);
      }
    }

    if (long_term_purpose && value === "Short-term Loans") {
      for (let product of short_term_purpose) {
        loan_products.push(product);
      }
    }

    this.setState({
      loan_products,
      loan_type: value,
    });
  }

  onChangeLoanProduct(e) {
    this.setState({ loan_product: e.target.value });
  }

  get_interest_rate(isLoadingSetting, app_id) {
    this.setState({
      isLoadingSetting,
    });

    let response = {};
    const body = {
      app_id,
      model: "setting",
    };
    AppClass.get_setting_data(body)
      .then((_data) => {
        if (_data.data.length > 0) {
          let data = _data.data[0];

          let loan_types = [],
            short_term_purpose = [],
            long_term_purpose = [],
            keys = Object.keys(data);

          if (keys.includes("short_term")) {
            loan_types.push("Short-term Loans");
            short_term_purpose = data.short_term;
          }

          if (keys.includes("long_term")) {
            loan_types.push("Long-term Loans");
            long_term_purpose = data.long_term;
          }

          this.setState({
            setting_id: data._id,
            loan_types,
            long_term_purpose,
            short_term_purpose,
            isLoadingSetting: false,
          });
        } else {
          toastMessage("error", "Sacco settings is missing");
        }

        this.setState({ isLoadingSetting: false });
      })
      .catch((err) => {
        response.error = "Error, " + err;
        this.setState({
          response,
          isLoadingSetting: false,
        });
      });
  }

  onChangeLoanID(e) {
    this.setState({ loan_id: e }, () => {
      this.get_loans(true);
    });
  }

  onChangeMember(e) {
    this.setState({ member: e }, () => {
      this.get_loans(true);
    });
  }

  onChangeStartingDate(e) {
    this.setState({ start_date: e.target.value, page: 1 }, () => {
      this.get_loans(true);
    });
  }

  onChangeEndDate(e) {
    this.setState({ end_date: e.target.value, page: 1 }, () => {
      this.get_loans(true);
    });
  }

  get_loans(isLoading) {
    this.setState({ isLoading });

    let { appid, loan_id, start_date, end_date, apps, limit, page, member } =
      this.state;

    let _appid = "";

    if (!appid || !appid?.value) {
      _appid = AppClass.get_app_ids(apps);
    } else {
      _appid = [appid.value];
    }

    let response = {};
    const statuses = ["approved", "disbursed", "cleared", "paused"];

    const body = {
      app_id: _appid,
      page_number: page,
      page_limit: limit,
    };

    if (this.state.status && this.state.status.value) {
      body["status"] = [this.state.status.value];
    } else {
      body["status"] = statuses;
    }

    if (start_date !== undefined || end_date !== undefined) {
      body["from_date"] = start_date;
      body["to_date"] = end_date;
    }

    if (loan_id && loan_id.value) {
      body["loan_id"] = loan_id.value;
    }

    if (member && member.value) {
      body["member_id"] = member._id;
    }

    AppClass.get_loandata(body)
      .then((res) => {
        const { data, pagination, summary } = res.data;


        this.setState({
          loans: data,
          summary,
          isLoading: false,
          totalItemsCount: pagination.total_records,
        });

        let loan_ids = [];

        for (let el of data) {
          loan_ids.push({
            label: el.loan_id,
            value: el.loan_id,
          });
        }
        this.setState({ loan_ids });
      })
      .catch((err) => {
        response.error = "Error, " + err;
        this.setState({
          response,
          isLoading: false,
        });
      });
  }

  delete_loan(id) {
    const input_data = {
      id,
      model: "loan",
    };

    AppClass.delete_data(input_data);
  }

  onChangeStatus(e) {
    this.setState({ status: e }, () => {
      this.get_loans(true);
    });
  }

  onImportLoans(e) {
    const { files } = e.target;
    const reader = new FileReader();

    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */

      const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
      const jsonData = this.convertToJson(data);

      let keys = jsonData.length > 0 ? Object.keys(jsonData[0]) : [];

      if (keys.length === 0) {
        return toastMessage("error", "Empty file format");
      }

      if (
        !keys.includes("Name") &&
        !keys.includes("Phone Number") &&
        !keys.includes("User ID") &&
        !keys.includes("Sacco") &&
        !keys.includes("Setting ID") &&
        !keys.includes("Sacco ID") &&
        !keys.includes("Requested Amount") &&
        !keys.includes("Balance") &&
        !keys.includes("Payment Duration") &&
        !keys.includes("Loan Product") &&
        !keys.includes("Loan Type") &&
        !keys.includes("Date")
      ) {
        return toastMessage("error", "Invalid loan file format");
      }

      this.setState({ isLoading: true });

      let length_data = 0;

      for (let i = 0; i < jsonData.length; i++) {
        if (
          jsonData[i]["Sacco"] &&
          jsonData[i]["Sacco ID"] &&
          jsonData[i]["User ID"] &&
          jsonData[i]["Setting ID"] &&
          jsonData[i]["Requested Amount"] &&
          jsonData[i]["Payment Duration"] &&
          jsonData[i]["Balance"] &&
          jsonData[i]["Name"] &&
          jsonData[i]["Loan Product"] &&
          jsonData[i]["Loan Type"] &&
          jsonData[i]["Status"] &&
          jsonData[i]["Date"]
        ) {
          length_data += 1;
          this.saveLoanData(jsonData[i], length_data - 1, i);
        }
      }
    };
    reader.readAsBinaryString(files[0]);
  }

  onPressFileImport(name, e) {
    this.refs[name].click();
  }

  saveLoanData = async (data, length, i) => {
    const input_data = {
      app_id: data["Sacco ID"],
      loan_id: data["Loan ID"] || this.generateRandomID(data["Sacco"]),
      organization: data["Sacco"],
      model: "loan",
      req_amount: data["Requested Amount"],
      amount: data["Balance"] || data["Ending Balance"],
      last_payment: data["Last Payment"] || 0,
      payment_info: JSON.stringify({
        exp_interest_rate: data["Interest"] || 0,
        exp_principle_payment: data["Principal"] || 0,
      }),
      interestrate: data["Setting ID"],
      payment_duration: data["Payment Duration"] || 12,
      total_interest: data["Total Interest"] || 0,
      total_payment: data["Total Payment"] || 0,
      user_id: data["User ID"] || "-",
      user_name: data["Name"] || "-",
      phone_number: data["Phone Number"] || "-",
      status: data["Status"] || "Accepted",
      available: true,
      date: new Date(data["Date"]).getTime(),
      purpose: data["Loan Product"],
      loan_type: data["Loan Type"],
    };

    const errors = AppClass.validate_form(input_data);

    if (!Object.keys(errors).length) {
      AppClass.add_data(input_data)
        .then(async (data) => {
          if (length === i) {
            toastMessage("success", "Data has been uploaded successfully");
            this.setState({ isLoading: false });

            this.get_loan_by_apps(true, this.props.apps);
          }
        })
        .catch((err) => {
          if (length === i) {
            toastMessage("error", "Data has been failed to be uploaded");
            this.setState({ isLoading: false });
          }
        });
    }
  };

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  handleOpenModal(modal) {
    this.setState({
      [modal]: true,
    });
  }

  get_app_setting(app_id) {
    this.setState({
      isLoadingSetting: true,
    });

    const body = {
      app_id,
      model: "setting",
    };
    return AppClass.get_setting_data(body);
  }

  randomString(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  generateRandomID(sacco_name) {
    return (
      sacco_name.split(" ")[0] +
      "-" +
      this.randomString(2).toUpperCase() +
      "" +
      new Date().getTime().toString().substring(0, 4)
    );
  }

  handleResetFilters() {
    this.setState(
      {
        member: undefined,
        loan_id: undefined,
        start_date: moment().subtract("30", "days").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      },
      () => {
        window.location.reload();
      }
    );
  }

  handleChangeLimit(e) {
    this.setState(
      {
        limit: e.target.value,
        page: 1,
      },
      () => {
        this.get_loans(true);
      }
    );
  }

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.get_loans(true);
      }
    );
  }

  get_members(app_id) {
    const { diladmin } = this.props;
    let body = {
      app_id,
      from_dil: diladmin + "",
    };
    AppClass.get_member(body)
      .then((data) => {
        let members = [];

        for (let el of data.data.data) {
          members.push({
            label: el.user_name,
            value: el.user_id,
            _id: el._id,
          });
        }
        this.setState({
          members,
          isLoading: false,
        });
      })
      .catch((err) => {
        toastMessage("error", err);
        this.setState({
          isLoading: false,
        });
      });
  }

  render() {
    const {
      apps,
      response,
      loans,
      isLoading,
      message,
      appid,
      loan_id,
      start_date,
      end_date,
    } = this.state;

    return (
      <div>
        <Filter
          appid={appid}
          loan_id={loan_id}
          onChangeLoanID={this.onChangeLoanID.bind(this)}
          apps={apps}
          loans={copyData}
          members={this.state.members}
          member={this.state.member}
          response={response}
          start_date={start_date}
          end_date={end_date}
          onChangeStartingDate={this.onChangeStartingDate.bind(this)}
          onChangeEndDate={this.onChangeEndDate.bind(this)}
          onChangeSacco={this.onChangeSacco.bind(this)}
          loan_ids={this.state.loan_ids}
          showReset={this.state?.appid?.value}
          handleResetFilters={this.handleResetFilters.bind(this)}
          onChangeMember={this.onChangeMember.bind(this)}
          statusOptions={[
            { value: 'approved', label: 'Approved' },
            { value: 'disbursed', label: 'Disbursed' },
            { value: 'cleared', label: 'Cleared' },
            { value: 'paused', label: 'Paused' },
            { value: 'rejected', label: 'Rejected' },
            { value: 'closed', label: 'Closed' }
          ]}
          status={this.state.status}
          onChangeStatus={this.onChangeStatus.bind(this)}
        />
        {isLoading ? (
          <Loading message={message} icon="fa fa-spinner fa-spin" />
        ) : (
          <>
            <div className="col-md-12 ">
              <div className="row">
                <CardCount
                  count={this.state.summary.no_of_loans}
                  title="No of Loans"
                />
                <CardCount
                    count={
                        "KES " +
                        formatMoney(this.state.summary.total_principal_amount)
                    }
                    title="Total Principal Amount"
                />
                <CardCount
                    count={
                        "KES " +
                        formatMoney(this.state.summary.total_interest_amount)
                    }
                    title="Total Interest Amount"
                />
                <CardCount
                  count={
                    "KES " +
                    formatMoney(this.state.summary.total_disbursed_amount)
                  }
                  title="Total Disbursed Amount"
                />
                <CardCount
                  count={
                    "KES " +
                    formatMoney(this.state.summary.total_repayments)
                  }
                  title="Total Repayments"
                />
                <CardCount
                  count={
                    "KES " +
                    formatMoney(this.state.summary.total_outstanding_amount)
                  }
                  title="Total Outstanding Amount"
                />
              </div>


              <div className="row">
                {Array.isArray(this.state.summary.total_loan_amount_by_product) && this.state.summary.total_loan_amount_by_product.length > 0 ? (
                  this.state.summary.total_loan_amount_by_product.map(product => (
                    <CardCount
                      key={product._id}
                      count={"KES " + formatMoney(product.total_balance)}
                      title={`${product.name.toUpperCase()} (${product.total_loans} loans)`}
                    />
                  ))


                ) : (
                  <div className="col-12 text-center text-muted">No loan product data available.</div>
                )}
              </div>
            </div>

            <Loan
              loans={loans}
              response={response}
              onPressFileImport={(e) =>
                this.onPressFileImport("loansUploader", e)
              }
              handleOpenTemplateModal={() =>
                this.handleOpenModal("template_modal")
              }
              fromDate={this.state.start_date}
              toDate={this.state.end_date}
              app_id={this.state.appid?.value}
              ztoken={this.props.ztoken}
              user_id={this.state.member?.value}
              pageLimit={this.state.limit}
              currentPage={this.state.page}
              status={this.state.status}
              member={this.state.member}
            />
            <Pagination
              totalItemsCount={this.state.totalItemsCount}
              page={this.state.page}
              limit={this.state.limit}
              handleChangeLimit={this.handleChangeLimit.bind(this)}
              handlePagination={this.handlePagination.bind(this)}
            />
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { filters } = state.Filters;
  return {
    filters,
  };
};

export default connect(mapStateToProps)(LoanList);
